import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { triggerBackup } from '../utils/triggerBackup'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useTriggerBackupMutation = () => {
  return useMutation({
    mutationFn: triggerBackup,
    onSuccess: () => {
      toast.success('Backup triggered successfully.')
    },
    onError: (error: ApiError) => {
      notifyRequestError(
        error,
        'An error occurred while triggering the backup.',
      )
    },
  })
}
